import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { AudioPlayerProvider } from "../context/AudioPlayerContext"; // Import AudioPlayerProvider
import { QuizSummaryProvider } from "../context/QuizSummaryContext";

export default function Layout({ children }) {
  return (
    <AudioPlayerProvider>
      <QuizSummaryProvider>
        <div className="layout-root">
          <Header />
          <main className="layout-main">{children}</main>
          <Footer />
        </div>
      </QuizSummaryProvider>
    </AudioPlayerProvider>
  );
}
